import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import "./WorkOrderActiveWorkItemTransition.css";

function WorkOrderActiveWorkItemTransition({ transition }) {
  const view = (
    <tr>
      <td>{transition.processOrder}</td>
      <td>{transition.transitionedBy}</td>
      <td>{transition.toStageType}</td>
      <td>
        {transition.transitionedAt
          ? moment(transition.transitionedAt).format("DD/MM/YYYY h:mm a")
          : ""}
      </td>
    </tr>
  );

  return view;
}

WorkOrderActiveWorkItemTransition.propTypes = {
  transition: PropTypes.shape({
    processOrder: PropTypes.number,
    transitionedBy: PropTypes.string,
    toStageType: PropTypes.string,
    transitionedAt: PropTypes.string,
  }).isRequired,
};

export default WorkOrderActiveWorkItemTransition;
